module.exports = __webpack_public_path__ + "static/media/wave01.24e8ef00.webp";